import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/constants/testIds";

const words = [
    "MOZZARELLA",
    "POMODORO",
    "FARINA",
    "OLIO EXTRAVERGINE",
    "BASILICO",
    "SALSICCIA",
    "ORIGANO",
    "VERDURE",
    "ACCIUGHE",
    "SALAMINO",
];

const EditorialMarquee = ({ inverted = false, speed = 30 }) => {
    return (
        <div
            data-testid={MARQUEE.strip}
            className={`border-y-2 border-[#0a0a0a] py-4 md:py-6 ${
                inverted ? "bg-[#0a0a0a] text-[#FFD600]" : "bg-[#FFD600] text-[#0a0a0a]"
            }`}
        >
            <Marquee gradient={false} speed={speed}>
                {words.concat(words).map((w, i) => (
                    <span
                        key={i}
                        className="font-display text-5xl md:text-7xl uppercase tracking-tight mx-8 flex items-center gap-8"
                    >
                        {w}
                        <span className="inline-block w-4 h-4 rounded-full bg-[#E63946]" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default EditorialMarquee;
